<script>
import { UserOrderRecord } from "@/store/entity/pay";
export default {
  name: "WechatPay",
  computed: {
    signupId() {
      if (this.$route.query.signupId) {
        return this.$route.query.signupId;
      } else {
        return null;
      }
    },
  },
  created() {
    if (typeof WeixinJSBridge === "undefined") {
      if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          this.onBridgeReady(),
          false
        );
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady());
        document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady());
      }
    } else {
      this.onBridgeReady();
    }
  },
  methods: {
    // 微信jsBridge ready后拉起支付
    async onBridgeReady() {
      const that = this;
      const wechat_code = this.GetUrlParam("code");
      const signupId = this.signupId;
      const orderInfo = await UserOrderRecord.createOrder({
        signup_id: signupId,
        wechat_code: wechat_code,
      });
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        orderInfo.sign_info,
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 订单接口设置成功
            UserOrderRecord.finisheOrder({ trade_no: orderInfo.trade_no }).then(
              (_) => {
                alert("支付成功！收款到账可能存在延时");
                that.$router.replace({ name: "pay" });
              }
            );

            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },
    getWechatCode() {},
    // 从请求参数截取微信的oauth code，用于oauth登录
    GetUrlParam(parameName) {
      /// 获取地址栏指定参数的值
      /// <param name="parameName">参数名</param>
      // 获取url中跟在问号后面的部分
      var parames = window.location.search;
      // 检测参数是否存在
      if (parames.indexOf(parameName) > -1) {
        var parameValue = "";
        parameValue = parames.substring(
          parames.indexOf(parameName),
          parames.length
        );
        // 检测后面是否还有参数
        if (parameValue.indexOf("&") > -1) {
          // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
          parameValue = parameValue.substring(0, parameValue.indexOf("&"));
          // 去掉参数名, 得到最终纯值字符串
          parameValue = parameValue.replace(parameName + "=", "");
          return parameValue;
        }
        return "";
      }
    },
  },
};
</script>
